export default function LoadingGlobal() {
    return (
        <div className="fixed inset-0 z-[9999] flex cursor-progress items-center justify-center bg-slate-950/40 p-4 backdrop-blur-[3px]">
            <div className="flex w-full max-w-[320px] flex-col items-center text-center">
                <div className="relative flex h-16 w-16 items-center justify-center">
                    <div className="absolute inset-0 animate-ping rounded-full bg-[#186cb2]/20" />
                    <div className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#186cb2]/30 bg-white shadow-lg">
                        <svg className="h-7 w-7 animate-[loadingPulse_1.5s_ease-in-out_infinite] text-[#186cb2]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M12 3V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M12 18V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M3 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M18 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M5.64 5.64L7.76 7.76" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M16.24 16.24L18.36 18.36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M18.36 5.64L16.24 7.76" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M7.76 16.24L5.64 18.36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                        </svg>
                    </div>
                </div>
                <p className="mt-3 text-sm font-semibold text-white drop-shadow-sm">
                    Please wait
                </p>
                <div className="mt-2 flex items-center justify-center gap-1">
                    <span className="h-1.5 w-1.5 animate-[loadingDot_1.4s_ease-in-out_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[loadingDot_1.4s_ease-in-out_0.2s_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[loadingDot_1.4s_ease-in-out_0.4s_infinite] rounded-full bg-[#186cb2]" />
                </div>
                <p className="mt-2 text-xs font-medium text-white/65">
                    Processing your request
                </p>
                <style>{`
                    @keyframes loadingPulse {
                        0%, 100% {
                            transform: rotate(0deg) scale(1);
                            opacity: 0.75;
                        }
                        50% {
                            transform: rotate(45deg) scale(1.08);
                            opacity: 1;
                        }
                    }
                    @keyframes loadingDot {
                        0%, 60%, 100% {
                            opacity: 0.25;
                            transform: translateY(0);
                        }
                        30% {
                            opacity: 1;
                            transform: translateY(-3px);
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}